import React from "react";

import "./CardListRow.css";

const CardListRow = (props) => {
  return <div onClick={props.onClick} className={`card-list-row__container ${props.className}`} id={props.id} >{props.children ? props.children : props.value}</div>;
};

export default CardListRow;
